import { Button, Visualizers } from "@app/shared";
import { InputRow, LabeledText } from "../../../shared";
import { Tab, TabContainer } from "../../../shared/TabContainer";
import { DataViewerProps } from "../DataViewer";
import { EditDeviceSettings } from "./EditDeviceSettings";
import { EditProjectFiles } from "./EditProjectFiles";
import { EditVideoSettings } from "./EditVideoSettings";

export const ConfigurationViewer: React.FC<DataViewerProps> = ({ closeProject, setProject, project, ...props }) => {
    const handleDeleteClick = async () => {
        await Visualizers.deleteProject(project.id);
        closeProject?.();
    };



    const radarEndDate = new Date((project.radarStartDate?.getTime() ?? 0) +
        (project.radarFrames?.length ?? 0) / (project.radarFps ?? 10) * 1000);

    return (
        <div className="flex flex-col flex-grow overflow-y-auto">
            <TabContainer className="flex-grow">
                <Tab title="General">
                    <InputRow>
                        <LabeledText label="Project Name">{project.name}</LabeledText>
                        <LabeledText label="Project ID">{project.id}</LabeledText>
                        <LabeledText label="Project Frame Type">{project.projectFrameType}</LabeledText>
                        <LabeledText label="Date Created">{project.created?.toDateString()}</LabeledText>
                        <LabeledText label="Video FPS">
                            {project.videoFps ?? 20} fps
                        </LabeledText>
                        <LabeledText label="Video Start Date">
                            {project.videoStartDate?.toDateString()} {project.videoStartDate?.toLocaleTimeString()}
                        </LabeledText>
                        <LabeledText label="Radar Frames">
                            {project.radarFrames?.length ?? 0}
                        </LabeledText>
                        {project.radarFrames?.length &&
                            <>
                                <LabeledText label="Radar FPS">
                                    {project.radarFps ?? 10} fps
                                </LabeledText>
                                <LabeledText label="Radar Start Date">
                                    {project.radarStartDate?.toDateString()} {project.radarStartDate?.toLocaleTimeString()}
                                </LabeledText>
                                <LabeledText label="Radar End Date">
                                    {radarEndDate.toDateString()} {radarEndDate.toLocaleTimeString()}
                                </LabeledText>
                            </>
                        }
                    </InputRow>

                    <InputRow>
                        <Button onClick={handleDeleteClick}>Delete Project</Button>
                    </InputRow>
                </Tab>
                <Tab title="Device">
                    <EditDeviceSettings project={project} setProject={setProject} />
                </Tab>
                <Tab title="Tracker">
                    <InputRow>
                        Tracker config
                    </InputRow>
                </Tab>
                <Tab title="Video">
                    <EditVideoSettings project={project} setProject={setProject} />
                </Tab>
                <Tab title="Files">
                    <EditProjectFiles project={project} setProject={setProject} />
                </Tab>
            </TabContainer>
            {/* <div className="w-full flex flex-row place-content-end">
                <Button>Sync to DB</Button>
            </div> */}
        </div >
    );
}